import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-4 mb-md-0">
            <h4>凱撒數位科技</h4>
            <p>CaesarTechStudio</p>
            <p>創新科技，卓越服務</p>
            {/* <div className="social-icons mt-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="mr-3">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="mr-3">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="mr-3">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
            </div> */}
          </div>
          <div className="col-md-4 mb-4 mb-md-0">
            <h4>快速連結</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/">{t('home')}</Link>
              </li>
              <li className="mb-2">
                <Link to="/about">{t('about')}</Link>
              </li>
              <li className="mb-2">
                <Link to="/services">{t('ourServices')}</Link>
              </li>
              <li className="mb-2">
                <Link to="/portfolio">{t('portfolio')}</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact">{t('contact')}</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <h4>{t('contact')}</h4>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="fas fa-map-marker-alt mr-2"></i> 南投縣南投市南新路341巷50號
              </li>
              {/* <li className="mb-2">
                <i className="fas fa-phone mr-2"></i> 0983-305-390
              </li> */}
              <li className="mb-2">
                <i className="fas fa-envelope mr-2"></i> karashuang@caesartechstudio.com
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom text-center">
          <p>
            &copy; {currentYear} {t('copyright')} <br />
            {t('allRights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 